module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-09-14 at 16.46.54_c20fbcc5.b7fbb714.jpg";